import axios from 'axios';
import { flashMessage } from 'redux-flash';
import { formatMessage } from 'utils/i18n';

export const FETCH_TAG_REQUEST = 'FETCH_TAG_REQUEST';
export const FETCH_TAG_SUCCESS = 'FETCH_TAG_SUCCESS';
export const FETCH_TAG_FAILURE = 'FETCH_TAG_FAILURE';

function fetchTagRequest() {
  return {
    type: FETCH_TAG_REQUEST
  }
}

function fetchTagFailure() {
  return {
    type: FETCH_TAG_FAILURE
  }
}

function fetchTagSuccess(tag) {
  return {
    type: FETCH_TAG_SUCCESS,
    tag
  }
}

export function fetchTag(siteId, slug, locale) {
  return dispatch => {
    dispatch(fetchTagRequest());
    return axios.get(`/sites/${siteId}/tags/${slug}`, {params: {locale: locale}})
      .then(response => {
        dispatch(fetchTagSuccess(response.data.tag));
      }).catch(error => {
        dispatch(fetchTagFailure());
        dispatch(flashMessage(formatMessage({id: "tag.not_found", defaultMessage: "Tag not found"}), {isError: true}));
      });
  }
}
